import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useMediaQueries } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { CreditsUnlocked } from './CreditsUnlocked';
import { IntroContentDesktop } from './IntroContentDesktop';
import { IntroContentMobile } from './IntroContentMobile';
import { useVideoProgress } from './useVideoProgress';
import { VideoPlayer } from './VideoPlayer';
export const GetIntroStepTID = (parentTestId)=>getTestIds({
        parentTestId
    });
const PLAYBACK_DURATION_MS = 80000;
const introStepTextsPath = 'vendorOnboarding.introStep';
export const IntroStep = (param)=>{
    let { testId, onSkip, onComplete } = param;
    const testIds = useMemo(()=>GetIntroStepTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys(introStepTextsPath);
    const { mobile: isMobile } = useMediaQueries();
    const [phase, setPhase] = useState('intro');
    const { progress, start, pause, reset } = useVideoProgress({
        durationMs: PLAYBACK_DURATION_MS,
        onComplete: ()=>setPhase('credits')
    });
    const handlePlay = useCallback(()=>{
        setPhase('playing');
        reset();
        start();
    }, [
        reset,
        start
    ]);
    const handleSkip = useCallback(()=>{
        pause();
        onSkip();
    }, [
        pause,
        onSkip
    ]);
    return /*#__PURE__*/ _jsxs(AnimatePresence, {
        mode: "wait",
        children: [
            phase === 'intro' && /*#__PURE__*/ _jsx(motion.div, {
                exit: {
                    opacity: 0
                },
                transition: {
                    duration: 0.3
                },
                style: {
                    height: '100%'
                },
                children: isMobile ? /*#__PURE__*/ _jsx(IntroContentMobile, {
                    testIds: testIds,
                    onPlay: handlePlay,
                    onSkip: handleSkip
                }) : /*#__PURE__*/ _jsx(IntroContentDesktop, {
                    testIds: testIds,
                    onPlay: handlePlay,
                    onSkip: handleSkip
                })
            }, "intro"),
            phase === 'playing' && /*#__PURE__*/ _jsx(VideoPlayer, {
                progress: progress,
                onPlay: start,
                onPause: pause,
                videoAlt: t.videoAlt(),
                isMobile: isMobile
            }),
            phase === 'credits' && /*#__PURE__*/ _jsx(CreditsUnlocked, {
                onComplete: onComplete,
                isMobile: isMobile
            })
        ]
    });
};
